"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicAdyenContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const c = (0, core_1.initContract)();
exports.publicAdyenContract = c.router({
    processNotification: {
        method: 'POST',
        path: '/process-notification',
        body: zod_1.z.any(),
        responses: {
            200: zod_1.z.object({ notificationResponse: zod_1.z.string() }),
        },
        summary: 'Webhook called by adyen',
    },
}, {
    pathPrefix: '/public',
});
//# sourceMappingURL=adyen.public.contract.js.map